import React from 'react'

export default function CrownWhiteIcon({ width = 28, height = 28, className }) {
  return (
    <svg width={width} height={height} className={className} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.33301 19.8335L4.66634 4.66683L10.4997 10.5002L13.9997 2.3335L17.4997 10.5002L23.333 4.66683L25.6663 19.8335H2.33301Z" fill="white"/>
    </svg>
  )
}
